import React from 'react';
import { PostWrapper } from './style';

// Components
import Link from 'components/common/Link';
import Image from 'next/image';
import Text from 'components/common/Text';

const PostItem = ({ 
  item: {id, link, image, subtitle, title}
}) => {

return (
    <PostWrapper 
        key={id}
    >
        <Link 
            to={link}
            className='post-item'
        >
            <Image
                src={image}
                alt={title}
                width={280}
                height={199}
                className='banner'
            />
            <Text 
                tag="h3"
                className="title"
            >  
                {title}
            </Text>
            <Text 
                tag="h4"
                className="subtitle"
            >  
                {subtitle}
            </Text>
        </Link>
    </PostWrapper>
)
};

export default PostItem;